import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Button, CardImg, Col, Row, Spinner } from "reactstrap";
import { getSingleFan } from "store/actions/athleteActions";
import { singleAthlete } from "store/actions/athleteActions";
import { verifyLicense } from "store/actions/fansActions";

const ScanBadges = () => {
  const { badgeID } = useParams();
  const dispatch = useDispatch();
  let { licenseVerify, licenseVerifyLoader } = useSelector(
    (state) => state.fan
  );

  let { athlete, singleFan, schoolLoading } = useSelector(
    (state) => state.athlete
  );
  useEffect(() => {
    dispatch(verifyLicense(badgeID));
  }, []);

  useEffect(() => {
    if (licenseVerify) {
      dispatch(singleAthlete(licenseVerify?.athlete_id));
      dispatch(getSingleFan(licenseVerify?.fan_id));
    }
  }, [licenseVerify]);

  return (
    <>
      <div>
        <h1 className="text-center mt-5">
          <b>FHP BADGE VERIFICATION</b>
        </h1>
      </div>
      <div className="verifyBox text-light mt-2 pb-2">
        <Row>
          <Col>
            <div className="d-flex justify-content-center align-items-center">
              {licenseVerifyLoader || schoolLoading ? (
                ""
              ) : licenseVerify ? (
                <i className="fas fa-check text-green mr-2 fa-lg"></i>
              ) : (
                <i className="fas fa-times text-danger mr-2 fa-lg"></i>
              )}
              <h2 className="pt-2">
                <b>Badge Status Report</b>
              </h2>
            </div>

            <h2 className="text-center mt-3">
              {licenseVerifyLoader || schoolLoading ? (
                <>
                  <Spinner
                    className="d-flex mx-auto align-items-center justify-content-center overflow-hidden"
                    size="sm"
                    color="blue"
                  />
                </>
              ) : licenseVerify ? (
                `The badge was bought by ${singleFan?.name} on ${moment
                  .unix(licenseVerify?.created_at.seconds)
                  .format("DD MMM YY")} from ${athlete?.first_name} ${
                  athlete?.last_name
                } for total price paid of ${licenseVerify?.amount.value}$.
 `
              ) : (
                "The badge you tried to check was invalid and does not exist"
              )}
            </h2>

            <br />
            <div class="d-flex justify-content-center">
              <Link to="/fan">
                <Button className="btn text-white bg-primary">
                  Back To Login
                </Button>
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ScanBadges;
